
define('template!supplierImprintTechnologiesFiltersEditView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="body">\n  <div class="line">\n    <div class="code item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="1" />\n    </div>\n    <div class="supplier item">\n      <div class="libelle">' +
((__t = ( _.i18n('product.supplier') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="2" />\n    </div>\n  </div>\n  <div class="line">\n    <!--<div class="name item">\n      <div class="libelle">' +
((__t = ( _.i18n('common.name') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="3" />\n    </div>-->\n    <div class="color-mode-type item">\n      <div class="libelle">' +
((__t = ( _.i18n('imprintTechnology.colorModeType') )) == null ? '' : __t) +
'</div>\n      <input type="text" tabindex="4" />\n    </div>\n    <div class="max-number-of-colors item">\n      <div class="libelle">' +
((__t = ( _.i18n('imprintTechnology.colorModeType') )) == null ? '' : __t) +
'</div>\n      <input type="number" min="0" tabindex="5" />\n    </div>\n  </div>\n</div>\n<div class="footer">\n  <div class="cancel-region"></div>\n  <div class="reset-region"></div>\n  <div class="confirm-region"></div>\n</div>\n';

}
return __p
};});

